<template>
  <div class="myorder">
    <show-scratch-card
      :scratchArrayValue="scratchArrayValue"
      :scratchSaleId="this.$route.query.orderId"
      :redeemId="scratchArrayValue.id"
      @closeScratch="closeScratch"
      v-if="isCloseScratch"
    />
    <ul v-if="orders.length > 0">
      <li v-for="(order, index) in orders" :key="index">
        <div class="order-id">
          <span class="ord-id">Order ID: #{{ order.orderId }}</span>
          <!-- <span
            class="text"
            @click="cancelOrder(order.orderId, index)"
            v-if="order.orderState != null && (order.orderState == 'CONFIRMED' || order.orderState == 'PAYMENT_SUCCESSFUL')">Cancel Order</span> -->
             <router-link tag="span" class="text" :to="{path : '/track-order/' + order.orderId}" >{{$t("trackOrder")}}</router-link>
        </div>
        <div
          class="product-details"
          @click="goToOrderDetail(order.orderId)"
        >
          <span class="product-img">
            <img :src="order.itemImage" alt="product-image" />
          </span>
          <div class="product-info">
            <div class="product-title">
              <h4>{{ order.itemName }}</h4>
              <span class="p-price">Rs. {{ order.totalPaidAmount }}</span>
            </div>
            <p class="date">
              {{$t('orderDate')}}: {{ order.orderDate.slice(0,  order.orderDate.indexOf(',') ) }} | Mode:
              <span
                v-if="
                (order.paymentMethod == 'ZYK_PAY' ||
                  order.paymentMethod == 'PAY91' || order.paymentMethod == 'ZYK_PAY_RAZORPAY')"
              >Online</span>
              <span v-else>{{ order.paymentMethod }}</span>
            </p>
            <div class="delivery-info">
              <span>
                {{$t('currentState')}}:
                <b :class="{'cancel': order.orderState =='CANCELLED_BY_USER','delivered': order.orderState =='ORDER_DELIVERED' }">
                  {{getText(order.orderState)
                  }}
                </b>
              </span>
              <img src="../../assets/images/icons/right-arrow.png" alt="right-arrow" />
            </div>
          </div>
        </div>
      </li>
    </ul>
    <infinite-loading @infinite="getOrdersListing" spinner="circles">
      <template slot="no-more">{{$t('noMoreRecord')}}</template>
    </infinite-loading>
  </div>
</template>

<script>
import constant from "../../utils/constant";
import InfiniteLoading from "vue-infinite-loading";
import ShowScratchCard from "../../components/OrderHistorySection/ShowScratchCard";
import Vue from "vue";
export default {
  name: "MyOrders",
  components: {
    InfiniteLoading,
    ShowScratchCard
  },
  data() {
    return {
      isCloseScratch: false,
      scratchArrayValue: {},
      limit: 20,
      orderIndex: 0,
      orders: [],
    };
  },
  methods: {
    getText(orderStatus) {
      let obj = constant.GETTEXT;
      return obj[orderStatus];
    },
    goToOrderDetail(orderId) {
      this.$cookie.set("orderStatus", "post_order");
      const _this = this;
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/shippingDetails/" + orderId);
    },
   
   
    getOrdersListing($state) {
      if (this.orderIndex != -1) {
        if (!$state) {
        }
        const Obj = {
          limit: this.limit,
          offset: this.orderIndex
        }
        this.$store
          .dispatch({
            type: "getUserOrder",
            payload: Obj,
          })
          .then(data => {
            $state && $state.loaded();
            if (data.data.length > 0) {
              this.orders = this.orders.concat(data.data);
              this.$store.commit("saveData", {
                orders: this.orders,
                orderIndex: this.orderIndex + 1,
                type: "post_order"
              });
              this.orderIndex = this.orderIndex + 1;
            } else {
              this.orderIndex = -1;
              $state && $state.complete();
            }
            setTimeout(() => {
              if (this.$route.query.orderId) {
                this.getScratchValue();
              }
            }, 2000);
          })
          .catch(err => {
            this.orderIndex = -1;
          });
      }
    },
    closeScratch() {
      this.isCloseScratch = !this.isCloseScratch;
    },
    getScratchValue() {
      const obj = {
        identifierSource: "ORDER",
        identifierId: this.$route.query.orderId,
        applicationId: "137"
      };
      this.$store
        .dispatch({
          type: "getScratchValue",
          payload: obj
        })
        .then(data => {
          if (data) {
            this.isCloseScratch = true;
            if (
              data &&
              data.data.status == "ACTIVE" &&
              data.data.scratchcardDTO.cardStatus == "INVISIBLE"
            ) {
              this.scratchArrayValue = data.data;
            } else if (
              this.scratchArray.status == "ACTIVE" &&
              this.scratchArray.scratchcardDTO.cardStatus == "ACTIVE"
            ) {
              this.scratchArrayValue = data.data;
            }
          } else {
            console.log("already scracthed");
          }
        });
    }
  },
  mounted() {
    if (this.$store.getters.orders.length > 0) {
      this.orders = this.$store.getters.orders;
      this.orderIndex = this.$store.getters.orderIndex;
    } else {
      // this.getOrdersListing();
    }
  }
};
</script>

<style>
</style>